import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError,defer, from } from 'rxjs';
import { catchError, tap, map, timeout } from 'rxjs/operators';
import { appServerResources } from '../app server constants';
import moment from 'moment';
import { normalizeUiMessage } from '../utils/message-normalizer';

@Injectable({
  providedIn: 'root'
})
export class BasehttpService {
  private readonly blockedRequestParamKeys = ['cookie', 'cookies', 'set-cookie', 'setcookie'];

  constructor(private httpClient: HttpClient) { }

  public get(url){
    const sanitizedUrl = this.sanitizeUrl(url);

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // 'Cache-Control': "no-cache, must-revalidate",
      // 'Expires': "Sat, 26 Jul 1997 05:00:00 GMT",
      'auth-token': localStorage.getItem('auth-token'),
      // "Accept": "application/json"
    });

    const httpOptions = {
      headers,
    };
    
    
    // console.log("-------------------------------------------------------------",url);
    // console.log("options -------------------------------------------------------------",httpOptions);
    return this.httpClient.get(sanitizedUrl, httpOptions)
      .pipe(
        timeout(50000),
        map(this.extractData),
        catchError(this.handleError)
      );


  }
  public get1(url){
    const sanitizedUrl = this.sanitizeUrl(url);

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // 'Cache-Control': "no-cache, must-revalidate",
      // 'Expires': "Sat, 26 Jul 1997 05:00:00 GMT",
      'auth-token': '8fc8e05d-873d-4ea5-9db4-d2442ce8983f',
      // "Accept": "application/json"
    });

    const httpOptions = {
      headers,
    };
    
    
    // console.log("-------------------------------------------------------------",url);
    // console.log("options -------------------------------------------------------------",httpOptions);
    return this.httpClient.get(sanitizedUrl, httpOptions)
      .pipe(
        timeout(50000),
        map(this.extractData),
        catchError(this.handleError)
      );


  }

  public postLogToServer(accountId,className,functionName,logString) {

    let userInfo = JSON.parse(localStorage.getItem('localUser'));
    let loggedinUserId :any;
    if(userInfo != null){
         loggedinUserId = userInfo.id
    }

    let cartItemsArray = JSON.parse(localStorage.getItem("cartArray"));
    let pinUserId = cartItemsArray.onlineOrderHeader.id;



    let postLogData: any = {
      accountId : accountId,
      appVersion : "Web",
      businessId : "",
      className : className,
      clientDateTime : moment().valueOf(),
      deviceId : "web",
      deviceType : "Web",
      functionName : functionName,
      ipAddress : "192.168.2.1",
      logLevel : "severe",
      logString : logString,
      loggedInUserId : loggedinUserId,
      pinInUserId : pinUserId,
      sessionId : "",
    }
    let ClientLog :any = {
      ClientLog : postLogData
    }


    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // 'Cache-Control': "no-cache, must-revalidate",
      // 'Expires': "Sat, 26 Jul 1997 05:00:00 GMT",
      'auth-token': localStorage.getItem('auth-token')
    });

    const options = {
      headers,
    };

    // console.log('url==>' + url);
    console.log('Post Object==>' + JSON.stringify(ClientLog));

    let url = appServerResources.SERVER_PATH + "NirvanaClientLoggerServiceV6/saveLog";
    return this.httpClient.post(url, JSON.stringify(ClientLog),options)
      .pipe(
        timeout(50000),
      );
  }
 


  public post(url, postData) {
    const sanitizedUrl = this.sanitizeUrl(url);
    const sanitizedPostData = this.removeCookieParams(postData);

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // 'Cache-Control': "no-cache, must-revalidate",
      // 'Expires': "Sat, 26 Jul 1997 05:00:00 GMT",
      'auth-token': localStorage.getItem('auth-token')
    });

    const options = {
      headers,
    };

    // console.log('url==>' + url);
    console.log('Post Object==>' + JSON.stringify(sanitizedPostData));

    return this.httpClient.post(sanitizedUrl, JSON.stringify(sanitizedPostData),options)
      .pipe(
        timeout(50000),
        map(this.extractData),
        catchError(this.handleError)
      );
  }

  public postForUrlEncodedType(url, postData) {
    const sanitizedUrl = this.sanitizeUrl(url);
    const sanitizedPostData = this.removeCookieParams(postData);

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      // 'Cache-Control': "no-cache, must-revalidate",
      // 'Access-Control-Allow-Origin': '*',
      // 'Expires': "Sat, 26 Jul 1997 05:00:00 GMT",
      'auth-token': localStorage.getItem('auth-token')
    });

    const options = {
      headers,
    };

    // console.log('url==>' + url);
   let postParams = this.serializeData(sanitizedPostData);

    return this.httpClient.post(sanitizedUrl, postParams, options)
      .pipe(
        timeout(50000),
         map(this.extractLoginData),
        catchError(this.handleError)
      );
  }


  private extractData(res: Response) {
    let body = res;
    return body || {};
  }

 private extractLoginData(res: any) {

      //  console.log(res.headers);
      //  console.log('nxp-token' + res.headers.get('nxp-access-token'));
    
      //  let access_token = res.headers.get('nxp-access-token')
      //  localStorage.setItem(appServerResources.NXP_ACCESS_TOKEN, access_token)
       let body = res;
       return body || {};
     }


  handleError(error) {
    let errorMessage: any = '';
    if (error?.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = error.error.message;
    } else if (error?.error?.displayMessage) {
      errorMessage = error.error.displayMessage;
    } else if (error?.message) {
      errorMessage = error.message;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error?.status}\nMessage: ${error?.statusText}`;
      if (error?.status == 0) {
        errorMessage = 'Unable to connect to Internet.Please check your network connectivity';
      }
    }

    const normalizedMessage = normalizeUiMessage(errorMessage || error);
    console.log(normalizedMessage);
    return throwError(normalizedMessage);
  }

  public serializeData(data) {

    //        // Polyfill isArray for IE 8
    //        if (!Array.isArray) {
    //            Array.isArray = function (arg) {
    //                return Object.prototype.toString.call(arg) === '[object Array]';
    //            };
    //        }
    
            // If this is not an object, defer to native stringification.
            if ( typeof data !== 'object') {
                return ((data == null) ? "" : data.toString());
            }
            var buffer = [];
    
            // Serialize each key in the object.
            for (var name in data) {
                if (!data.hasOwnProperty(name)) {
                    continue;
                }
                var value = data[name];
    
                // If this is an array, we need to loop through all array elements
                if (Array.isArray(value)) {
                    for (var i = 0; i < value.length; i++) {
                        var val = value[i];
                        buffer.push(
                            encodeURIComponent(name) + "=" +
                            encodeURIComponent((val == null) ? "" : val)
                        )
                    }
                }
                else {
                    buffer.push(
                        encodeURIComponent(name) + "=" +
                        encodeURIComponent((value == null) ? "" : value)
                    )
                }
            }
            // Serialize the buffer and clean it up for transportation.
            var source = buffer
                .join("&")
                .replace(/%20/g, "+")
                ;
            return (source);
        }

  private sanitizeUrl(url: string): string {
    if (!url || url.indexOf('?') === -1) {
      return url;
    }

    const urlSplitByHash = url.split('#');
    const mainUrl = urlSplitByHash[0];
    const hashFragment = urlSplitByHash.length > 1 ? urlSplitByHash.slice(1).join('#') : null;

    const queryStartIndex = mainUrl.indexOf('?');
    if (queryStartIndex === -1) {
      return url;
    }

    const basePath = mainUrl.substring(0, queryStartIndex);
    const queryString = mainUrl.substring(queryStartIndex + 1);
    const filteredParams = queryString
      .split('&')
      .filter(param => {
        if (!param) {
          return false;
        }
        const keyValueSplit = param.split('=');
        const rawKey = keyValueSplit[0];
        let decodedKey = rawKey;
        try {
          decodedKey = decodeURIComponent(rawKey);
        } catch (error) {
          decodedKey = rawKey;
        }
        return !this.shouldStripCookieKey(decodedKey);
      });

    const sanitizedUrl = filteredParams.length ? `${basePath}?${filteredParams.join('&')}` : basePath;
    return hashFragment ? `${sanitizedUrl}#${hashFragment}` : sanitizedUrl;
  }

  private removeCookieParams(data: any): any {
    if (data === null || data === undefined) {
      return data;
    }

    if (Array.isArray(data)) {
      return data.map(value => this.removeCookieParams(value));
    }

    if (Object.prototype.toString.call(data) !== '[object Object]') {
      return data;
    }

    const cleanedData = {};
    Object.keys(data).forEach((key) => {
      if (this.shouldStripCookieKey(key)) {
        return;
      }
      cleanedData[key] = this.removeCookieParams(data[key]);
    });

    return cleanedData;
  }

  private shouldStripCookieKey(key: string): boolean {
    if (!key) {
      return false;
    }
    const normalizedKey = key.trim().toLowerCase();
    return this.blockedRequestParamKeys.indexOf(normalizedKey) >= 0;
  }



}
